import utilify from '@prophecy/utils/react/utilify';
import styled from 'styled-components';

import { SIDE_NAVBAR_WIDTH } from '../Layout';
import { Spinner } from './Spinner';
import { tokens } from './tokens';
import { SpinnerProps } from './types';

const StyledSpinner = styled(Spinner)<{ allowSideBar?: boolean; leftOffset?: number }>`
  position: fixed;
  z-index: ${tokens.OverlaySpinner.zIndex};
  top: 0;
  left: ${({ allowSideBar, leftOffset = 0 }) =>
    allowSideBar ? parseInt(SIDE_NAVBAR_WIDTH) + leftOffset : leftOffset}px;
  right: 0;
  bottom: 0;
  pointer-events: auto;
`;

type GlobalSpinnerProps = Omit<SpinnerProps, 'children'> & {
  allowSideBar?: boolean;
  leftOffset?: number;
};

export const OverlaySpinner = (props: GlobalSpinnerProps) => {
  return (
    <StyledSpinner
      spinning={true}
      {...props}
      data-test-id='global-spinner'
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}>
      {/** Adding dummy children to have overlay for spinner */}
      <div />
    </StyledSpinner>
  );
};

const overlaySpinner = utilify<unknown, { show: (props?: GlobalSpinnerProps) => void; hide: () => void }>(
  ({ render, unmount }) => {
    const show = (props: GlobalSpinnerProps = {}) => {
      render(<OverlaySpinner {...props} />);
    };

    const hide = () => {
      unmount();
    };

    return {
      show,
      hide
    };
  }
)({});

OverlaySpinner.show = overlaySpinner.show;
OverlaySpinner.hide = overlaySpinner.hide;
